import React from "react";
import { FaPlus, FaRobot } from "react-icons/fa";
import { useNavigate } from "react-router-dom";

const AIAssistants = () => {
  const navigate = useNavigate();

  return (
    // Main container with background and consistent padding
    <div className="bg-slate-100 min-h-screen p-8 lg:p-12 font-sans">
      <div className="max-w-6xl mx-auto">
        {/* Header Section */}
        <header>
          <h1 className="text-4xl font-bold text-slate-800">AI Assistants</h1>
          <p className="mt-3 text-slate-600 max-w-4xl leading-relaxed">
            Create intelligent AI Assistants powered by{" "}
            <span className="font-semibold text-blue-500">AI Worker</span> and OpenAI.
            Configure their behavior, roles, and integrations with popular platforms like
            websites, chat interfaces, and customer portals. To create an assistant, click on
            the{" "}
            <span className="font-semibold text-slate-700">+ New assistant</span> button below.
            <br />
            You’ll need a valid{" "}
            <a
              href="/dashboard/openai-settings"
              className="font-semibold text-blue-500 hover:text-cyan-400 transition-colors"
            >
              OpenAI key
            </a>{" "}
            before you can deploy an assistant.
          </p>
        </header>

        {/* Main Content Card */}
        <div className="mt-16 bg-white rounded-xl shadow-sm p-8 relative">
          {/* "+ New assistant" Button */}
          <button
            onClick={() => navigate("/dashboard")}
            className="absolute top-0 left-8 -translate-y-1/2 flex items-center gap-2 bg-blue-500 text-white font-semibold px-5 py-2 rounded-lg shadow-md hover:bg-blue-600 transition-all focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500"
          >
            <FaPlus className="text-lg" />
            New Assistant
          </button>

          {/* Call-to-Action Section */}
          <div className="flex flex-col items-center justify-center text-center py-24">
            <FaRobot className="text-blue-500 text-6xl mb-6" />
            <h2 className="text-4xl font-medium text-slate-800 max-w-2xl leading-tight">
              <span className="font-bold text-blue-500">Create your first AI Assistant</span> to
              personalize and automate your workflows
            </h2>
            <p className="mt-6 text-slate-700 text-lg">
              Use your OpenAI key to design assistants that can chat, answer, or perform tasks
              automatically.
            </p>
            <button
              onClick={() => navigate("/dashboard/openai-settings")}
              className="mt-8 flex items-center gap-3 bg-blue-500 text-white font-bold px-6 py-3 rounded-lg shadow-lg hover:bg-blue-600 hover:shadow-cyan-400/30 transform hover:-translate-y-1 transition-all duration-300 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500"
            >
              Get OpenAI key
              <span aria-hidden="true">&rarr;</span>
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AIAssistants;
